<template>
  <el-container direction='vertical' style="background-color: #eee;">
    <el-container>
      <div class="goods-details" v-if="goodsDetails">
        <div class="gd-img-content">
          <img :src="goodsDetails.mainimg">
          <div class="gd-title">
            <span>{{goodsDetails.title}}</span>
          </div>
        </div>
        <div class="gd-desc-content">
          <div class="gd-needpoints"><span>{{goodsDetails.needpoints}}</span>积分</div>
          <div class="gd-desc">
            <div class="stock">销量<span class="gray">{{goodsDetails.exchanged}}</span></div>
            <!-- <div class="exchanged">已兑换<span class="red">{{goodsDetails.exchanged}}</span>件</div> -->
          </div>
        </div>
        <div class="gd-need-content" style="border-top: 16px solid #eee;">
          <span class="title">兑换须知</span>
          <div  v-html="transferString(goodsDetails.description)"></div>
        </div>
        <div class="gd-details">
          <span class="title">商品详情</span>
          <div v-html="goodsDetails.content"> </div>
        </div>
      </div>
      <div class="credit-btn" v-if="goodsDetails && userInfo">
        <div class="pay-contnet">
          <div class="pay-top">
            <div class="pay-top-left" v-if="goodsDetails">
              <el-button v-if="parseInt(goodsDetails.stock) <= 0" type="success" disabled >库存不足</el-button>
              <el-button  v-else  @click="requestPay" type="success" :disabled="isNeedpointsEnough">{{isNeedpointsEnough ? '积分不足' : '立即兑换'}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-container>
    <el-dialog title="交易详情" :show-close='false' class="success-dialog" fullscreen :visible.sync="show">
      <div class="success-vessel" v-if="goodsDetails">
        <div class="success-icon"></div>
        <div class="success-text">支付成功</div>
        <div class="success-amount">积分-{{goodsDetails.needpoints}}</div>
        <div class="success-btn">
          <el-button @click="requestSuccess" type="success">完成</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { getUserInfo } from '@/views/mobile/MemberCenter/apis'
import { goodsInfoApi, exchangeApi } from '@/views/mobile/GoodsList/apis'

export default {
  data () {
    return {
      userInfo: null,
      id: null,
      goodsDetails: null,
      show: false,
      isClick: true
    }
  },
  computed: {
    isNeedpointsEnough () {
      return parseInt(this.userInfo.points) < parseInt(this.goodsDetails.needpoints)
    }
  },
  methods: {
    transferString (content) {
      let string = content
      try {
        string = string.replace(/\r\n/g, '<br>')
        string = string.replace(/\n/g, '<br>')
      } catch (e) {
        console(e.message)
      }
      return string
    },
    requestUserInfo () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          if (result) {
            this.userInfo = result.data
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                id: 'pay-id',
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
          }
        }).catch(error => {
          if (error) {
          }
        })
    },
    getGoodsDetails () {
      let data = new FormData()
      data.append('id', this.id)
      data.append('fromUrl', window.location.href)
      this.loading = this.$toast.loading()
      goodsInfoApi(data)
        .then(result => {
          if (result) {
            this.loading.hide()
            this.goodsDetails = result.data
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    requestPay () {
      let title = '积分' + this.goodsDetails && this.goodsDetails.needpoints
      let that = this
      this.isClick = true
      this.$dialog({
        id: 'credit-dialog',
        title: title,
        content: '确认消耗积分兑商品',
        closeBtn: true,
        onOkBtn (event) {
          this.close()
          if (that.isClick) {
            that.requestCredit()
            that.isClick = false
          } else {
            return false
          }
        }
      })
    },
    requestCredit () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('id', this.$route.query.id)
      exchangeApi(data)
        .then(result => {
          if (result) {
            this.getGoodsDetails()
            this.show = true
          }
        })
    },
    requestSuccess () {
      this.$router.push('/goodsList')
    }
  },
  mounted () {
    this.requestUserInfo()
    this.getGoodsDetails()
    this.$nextTick(() => {
      document.getElementsByClassName('wrapper-mobile')[0].style.backgroundColor = '#eee'
    })
  },
  destroyed () {
    document.getElementsByClassName('wrapper-mobile')[0].style.backgroundColor = '#fff'
  },
  created () {
    this.id = this.$route.query.id ? this.$route.query.id : null
  }
}
</script>
<style lang="less" >
.goods-details{
  width: 100%;
  margin-bottom: 76px;
  .red{
    color: red;
  }
  .gd-img-content{
    width: 100%;
    position: relative;
    overflow: hidden;
    img{
      min-height: 320px;
      width: 100%;
      float: left;
    }
    .gd-title{
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      padding:16px 16px;
    }
  }
  .gd-desc-content{
    padding: 16px 16px ;
    background-color: #fff;
  }
  .gd-need-content{
    padding: 8px 16px ;
    line-height: 28px;
    background-color: #fff;
  }
  .gd-needpoints{
    span{
      font-size: 20px;
      color: #000;
    }
  }
  .gd-desc{
    overflow: hidden;
    margin-top: 8px;
    .stock{
      float: left;
    }
    .exchanged{
      float: right;
    }
  }
  .gd-details{
    padding: 16px 16px 8px 16px;
    p{
      line-height: 28px;
      margin: 0;
    }
    background-color: #fff;
    img{
      max-width: 100%;
      height: auto;
    }
  }
  .title{
    color: #000;
    display: block;
    line-height: 28px;
    font-weight: 600;
    margin: 6px 0;
    font-size: 18px;
  }
}
.credit-btn {
    position: fixed;
    bottom: 16px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: transparent;
    padding:0px 24px;
    width: 100%;
    max-width: 750px;
    .pay-contnet {
      .pay-top {
        overflow: hidden;
        .pay-top-left,
        .pay-top-right {
          float: left;
          width: 100%;
          text-align: center;
          padding: 0;
          // padding-right: 8px;
          .el-button {
            width: 100%;
            font-size: 18px;
            border-radius: 24px
          }
        }
        .pay-top-right {
          padding: 0;
          padding-left: 8px;
        }
      }
    }
  }
#credit-dialog {
  .nut-dialog-ok {
    background: linear-gradient(315deg, #68c937 0%, #67c23a 100%) !important;
  }
  .nut-dialog-ok:active {
    background: inherit;
  }
}
.success-dialog {
  padding-top: 0;
  .el-dialog__header {
    display: none;
    background: #333;
    padding: 10px 20px;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }
  }
  .success-vessel {
    position: absolute;
    left: 0;
    top: 100px;
    width: 100%;
  }
  .success-text {
    color: #67c23a;
    text-align: center;
    margin-top: 20px;
    font-size: 20px;
  }
  .success-amount {
    text-align: center;
    margin-top: 30px;
    font-size: 36px;
    color: #000;
  }
  .success-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    background-image: url(assets/images/success.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .success-btn {
    padding: 0 30px;
    margin-top: 50px;
    box-sizing: border-box;
    .el-button {
      width: 100%;
      margin: 0 auto;
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/GoodsList/goodsDetails.vue